// ข้อความภาษาไทยที่ engine สร้างเอง (อายุ สาเหตุการตาย ชื่อที่แสดง)

import type { DeathCause, Diet, Habitat, SpeciesInfo } from "./types";

export const DIET_TH: Record<Diet, string> = {
  herbivore: "กินพืช",
  carnivore: "กินเนื้อ",
  omnivore: "กินทั้งพืชและสัตว์",
  insectivore: "กินแมลง",
};

export const HABITAT_TH: Record<Habitat, string> = {
  forest: "ป่า",
  grassland: "ทุ่งหญ้า",
  wetland: "พื้นที่ชุ่มน้ำ",
  freshwater: "น้ำจืด",
  sea: "ทะเล",
  mountain: "ภูเขา",
  cave: "ถ้ำ",
  desert: "ทะเลทราย",
  urban: "เมือง",
};

export const DEATH_CAUSE_TH: Record<DeathCause, string> = {
  predator: "ถูกนักล่าจับกิน",
  starvation: "อดอาหาร",
  disease: "ป่วยหรือติดปรสิต",
  accident: "อุบัติเหตุ",
  disaster: "ภัยธรรมชาติ",
  human: "ภัยจากมนุษย์",
  old_age: "จากไปอย่างสงบเพราะอายุมาก",
  sacrifice: "สละชีวิตเพื่อครอบครัว",
};

// ข้อความตอนตายจากความเสี่ยงพื้นฐาน ไข่และดักแด้ใช้ข้อความแยก
export const BASE_DEATH_TEXT: Record<Exclude<DeathCause, "starvation" | "old_age" | "sacrifice">, { active: string; dormant: string }> = {
  predator: {
    active: "นักล่าเห็นคุณก่อนที่คุณจะเห็นมัน และทุกอย่างจบลงอย่างรวดเร็ว",
    dormant: "มีสัตว์ตัวหนึ่งมาพบคุณ และคุณกลายเป็นอาหารมื้อเล็กๆ ของมัน",
  },
  disease: {
    active: "ร่างกายของคุณติดเชื้อและอ่อนแรงลงทุกวัน จนไม่ฟื้นอีกเลย",
    dormant: "เชื้อราค่อยๆ ลุกลามเข้ามา คุณไม่มีโอกาสได้ฟักออกมา",
  },
  accident: {
    active: "อุบัติเหตุเล็กๆ ที่ไม่มีใครคาดคิดกลายเป็นเรื่องใหญ่",
    dormant: "บางอย่างกระแทกเข้ามาอย่างแรง และคุณแตกเสียหาย",
  },
  disaster: {
    active: "พายุใหญ่พัดถล่มถิ่นที่อยู่ของคุณ และคุณไม่รอด",
    dormant: "น้ำท่วมใหญ่พัดคุณหายไปกับกระแสน้ำ",
  },
  human: {
    active: "กิจกรรมของมนุษย์มาถึงถิ่นที่อยู่ของคุณ และคุณหนีไม่ทัน",
    dormant: "พื้นที่ของคุณถูกมนุษย์ไถกลบไปทั้งหมด",
  },
};

/** ชื่อที่ใช้แทน {name} ในข้อความ ถ้ายังไม่มีชื่อไทยใช้ชื่อวิทยาศาสตร์ */
export function displayName(species: SpeciesInfo): string {
  return species.nameTh ?? species.sci;
}

/** อายุในหน่วยที่เหมาะกับชนิดนั้นโดยอัตโนมัติ (ข้อ 3.2) */
export function formatAge(days: number): string {
  const d = Math.max(0, days);
  if (d === 0) return "แรกเกิด";
  if (d < 1) return `${Math.max(1, Math.round(d * 24))} ชั่วโมง`;
  if (d < 14) return `${Math.round(d)} วัน`;
  if (d < 60) return `${Math.round(d / 7)} สัปดาห์`;
  if (d < 730) return `${Math.round(d / 30.4)} เดือน`;
  return `${Math.round(d / 365)} ปี`;
}

export function renderText(template: string, vars: Record<string, string | number>): string {
  return template.replace(/\{(\w+)\}/g, (match, key: string) =>
    key in vars ? (typeof vars[key] === "number" ? vars[key].toLocaleString("th-TH") : String(vars[key])) : match,
  );
}
